import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Stepper, Step } from "@progress/kendo-react-layout";
import { SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE } from "../../../routes";

const items = [
  {
    label: "Max Geofence Area and Seats",
    value: 0,
  },
  {
    label: "Review",
    value: 1,
  }
];


export const ShuttleBusBookingSetMaximumSteps = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = query.get("id");
  const handleChange = (e) => {
    // e.preventDefault();
    if (e.value != 0) {
      if (props.checkMandatoryFields()) return;
    }
    if (query.get("id")) {
      props.setState(e.value);
      query.set("state", e.value);

      navigate(SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE + "?" + query.toString());
    } else {
      props.handleSubmit(false);
    }
  };

  return (
    <>
      <div className="shuttle_bus_booking-steps-group">
        <div className="progress-steps-inside-group">
          <Stepper
            className="shuttle_bus_booking_steps"
            value={props.state}
            items={items}
            // item={CustomStep}
            onChange={(e) => handleChange(e)}
          />
        </div>
      </div>
    </>
  );
};